import React, { useEffect, useState } from "react";
import { Form, Select, InputNumber, Row, Col, Typography, message } from "antd";
import { CommonService } from "../../../../services/Common/CommonService";
import { CommonDropdownParams } from "../../../../constants/CommonDropdownParams";
import { DropdownsResponse } from "../../../../models/ICommon";
import { InvoiceDefaultResponse } from "../../../../services/Invoices/CreatorProfile/CreatorProfileService";
import CustomFields, { CustomField } from "../../../comman/CustomFields/CustomFields";
import { mapBackendToCustomFields, mapTaxDetailsToCustomFields, mapCustomFieldsToJson } from "../../../comman/CustomFields/CustomFieldMapper";
import { GlobalButton } from "../../../comman/GlobalButton.styles";
import LabelWithTooltip from "../../../comman/LabelWithTooltip.tsx/LabelWithTooltip";

const { Option } = Select;
const { Text } = Typography;
export interface taxDetails {
	taxName: string;
	taxPercent: number;
}

export interface InvoiceFormValues {
	defaultCurrencyId: number;
	// taxPercent: number;
	paymentTermsDays: number;
	taxDetails: taxDetails[];
	additionalDataJson: string;
}

interface InvoiceDefaultsFormProps {
	initialValues?: Partial<InvoiceDefaultResponse>;
	currencyCountryId: number;
	// initialValues?: Partial<{ defaultTax?: number; defaultCurrency: string; paymentDueDays: number }>;
	onSave: (values: InvoiceFormValues) => void;
	loading?: boolean;
}

const InvoiceDefaults: React.FC<InvoiceDefaultsFormProps> = ({ initialValues, currencyCountryId, onSave, loading }) => {
	const [form] = Form.useForm<InvoiceFormValues>();
	const [customFields, setCustomFields] = useState<CustomField[]>([]);
	const [taxFields, setTaxFields] = useState<CustomField[]>([]);
	const [pageLoading, setPageLoading] = useState<boolean>(false);
	const [dropdowns, setDropdowns] = useState<DropdownsResponse>({});

	const currencies =
		dropdowns?.CountriesFromCountryMaster?.filter((item) => item.label === "UNITED STATES" || item.id === currencyCountryId).map((item) => {
			const parsed = JSON.parse(item.value);
			return {
				id: item.id,
				label: parsed.Currency
			};
		}) || [];

	useEffect(() => {
		getCommonDropdown([CommonDropdownParams.CountryFromCountryMaster]);
	}, []);

	useEffect(() => {
		if (initialValues) {
			const fields = mapBackendToCustomFields(initialValues?.additionalFieldData);
			setCustomFields(fields);
			const taxFields = mapTaxDetailsToCustomFields(initialValues?.taxDetails);
			setTaxFields(taxFields);
			form.setFieldsValue(initialValues);
		}
	}, [initialValues, form]);

	const getCommonDropdown = (ids: number[]) => {
		setPageLoading(true);
		CommonService.getAllDropdowns(ids)
			.then((rawData) => {
				setDropdowns(rawData);
			})
			.catch((error) => {
				message.error("Failed to load dropdowns");
			})
			.finally(() => setPageLoading(false));
	};

	const mappedTaxDetails: taxDetails[] = taxFields.map((f) => ({
		taxName: f.label,
		taxPercent: Number(f.value)
	}));

	const onFinish = (values: InvoiceFormValues) => {
		const finalValues = {
			...values,
			taxDetails: mappedTaxDetails,
			additionalDataJson: mapCustomFieldsToJson(customFields)
		};
		onSave(finalValues);
	};

	return (
		<>
			<Text type="secondary" className="block mb-6">
				You can change these settings later on individual invoices
			</Text>
			<Form form={form} layout="vertical" onFinish={onFinish} initialValues={initialValues}>
				<Row gutter={[16, 16]}>
					{/* <Col xs={24} sm={12} md={8}>
						<Form.Item name="taxPercent" label={<LabelWithTooltip label="Default Tax %" tooltip="..." />}>
							<InputNumber min={0} max={100} className="w-full" />
						</Form.Item>
					</Col> */}
					<Col xs={24} sm={12} md={8}>
						<Form.Item
							name="defaultCurrencyId"
							label={<LabelWithTooltip label="Default Currency" tooltip="..." />}
							rules={[{ required: true }]}
						>
							<Select>
								{currencies.map((c) => (
									<Option key={c.id} value={c.id}>
										{c.label}
									</Option>
								))}
							</Select>
						</Form.Item>
					</Col>
				<Col xs={24} sm={12} md={8}>
						<Form.Item
							name="paymentTermsDays"
							label={
								<LabelWithTooltip
									label="Payment Due In"
									tooltip="Set how many days after the invoice date the payment is due. This will be applied automatically to all new invoices."
								/>
							}
							rules={[
								{ required: true, message: "Payment terms are required" },
								{
									type: "number",
									min: 1,
									max: 90,
									message: "Payment due days must be between 1 and 90"
								}
							]}
						>
							<InputNumber min={1} addonAfter="days" className="w-full" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12}>
						<Form.Item label="Add Tax %">
							<CustomFields customFields={taxFields} setCustomFields={setTaxFields} labelField="Tax" />
						</Form.Item>
					</Col>
					<Col xs={24} md={12}>
						<Form.Item label="Custom Fields">
							<CustomFields customFields={customFields} setCustomFields={setCustomFields} />
						</Form.Item>
					</Col>
				</Row>

				<div className="d-flex justify-content-center mt-5">
					<GlobalButton className="primary" htmlType="submit" loading={loading} size="large">
						Save Invoice Defaults
					</GlobalButton>
				</div>
			</Form>
		</>
	);
};

export default InvoiceDefaults;
